import { createAction } from '@reduxjs/toolkit'
import { PostDestination } from 'shared'

export * from './buckets/actions'
export * from './deletePost/actions'
export * from './getPosts/actions'
export * from './recyclePost/actions'
export * from './reorderPosts/actions'
export * from './requeuePosted/actions'
export * from './shufflePosts/actions'

export const setSelectedProfiles = createAction<{ profiles: PostDestination[], activeView?: 'calendar' | 'posts' | 'history' }>(
  'posts/setSelectedProfiles'
)
